import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import { Avatar, Grid, Typography } from "@mui/material";

import { useAxios } from "../../../hooks";
import { ErrorButton } from "../../css components/Button";
import { ComponentHeader, Label, TextField } from "../../../components";

const ImageAvatar = styled(Avatar)`
  height: 130px;
  width: 130px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
`;

const AllowedImage = styled(Typography)`
  color: #333;
  font-size: 15px;
  opacity: 0.8;
  margin-top: 15px;
`;

export default function FormOne({ formikProps, editState }) {
  // const [resolvedAvatar, setResolvedAvatar] = useState("");
  const axios = useAxios({
    headers: "formData",
  });
  const [loading, setLoading] = useState(false);
  const { siteColors } = useSelector((state) => state.renderUIDetails);
  // useEffect(() => {
  //   async function resolveAvatar() {
  //     const url = formikProps.values.brandAvatar;
  //     console.log("Resolving avatar for URL:", url);
  //     if (!url) {
  //       setResolvedAvatar("");
  //       return;
  //     }

  //     // Already a direct URL
  //     if (url.includes("storage.googleapis.com")) {
  //       setResolvedAvatar(url);
  //       return;
  //     }

  //     try {
  //       const response = await fetch(url, {
  //         method: "GET",
  //         redirect: "follow",
  //       });
  //       console.log("response URL:", response);
  //       setResolvedAvatar(response.url);
  //     } catch (err) {
  //       console.error("Failed to resolve avatar:", err);

  //       // fallback to original
  //       setResolvedAvatar(url);
  //     }
  //   }

  //   resolveAvatar();
  // }, [formikProps.values.brandAvatar]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <ComponentHeader title={"Brand Details"} subtitle={""} />
      </Grid>

      <Grid item textAlign="center" display="flex">
        <ImageAvatar src={formikProps.values.brandAvatar} />{" "}
      </Grid>

      {editState && (
        <Grid item alignSelf={"center"}>
          <div style={{ display: "flex" }}>
            <input
              disabled={!editState || loading}
              accept=".jpg,.jpeg,.png"
              style={{
                display: "none",
                pointerEvents: loading ? "none" : "auto",
              }}
              id="avatar-button-file"
              multiple
              onChange={(event) => handleFileChange(event, "brandAvatar")}
              type="file"
            />
            <label htmlFor="avatar-button-file">
              <div
                className="add-new-logo"
                variant="contained"
                style={{
                  marginRight: "10px",
                  pointerEvents: loading ? "none" : "auto",
                  backgroundColor: loading ? "#cbcbcb" : siteColors?.primary,
                }}
              >
                {loading ? "Uploading..." : "Add New Logo"}
              </div>
            </label>

            {formikProps.values.brandAvatar && (
              <ErrorButton
                variant="outlined"
                onClick={() => {
                  formikProps.setValues((prev) => ({
                    ...prev,
                    brandAvatar: "",
                  }));
                }}
              >
                Reset
              </ErrorButton>
            )}
          </div>

          <AllowedImage>
            Allowed JPG, GIF or PNG
            {/* {!formikProps.values.brandAvatar && (
              <CgAsterisk style={{ color: colors.error }} />
            )} */}
            .
          </AllowedImage>
        </Grid>
      )}

      <Grid item xs={12}></Grid>

      <Grid item xs={4}>
        <Label title={"Brand Name"} />

        <TextField
          disabled={!editState}
          formikProps={formikProps}
          placeholder="Brand Name"
          name="brandName"
          required
          inputProps={{ maxLength: 35 }}
        />
      </Grid>

      <Grid item xs={4}>
        <Label title={"Website"} />

        <TextField
          disabled={!editState}
          formikProps={formikProps}
          name="website"
          placeholder="Website"
          inputProps={{ "aria-label": "Without label" }}
        />
      </Grid>

      <Grid item xs={4}>
        <Label title={"Online Store"} />

        <TextField
          disabled={!editState}
          formikProps={formikProps}
          name="onlineStore"
          placeholder="Online Store"
        />
      </Grid>

      <Grid item xs={12}>
        <Label title={"About"} />

        <TextField
          disabled={!editState}
          formikProps={formikProps}
          placeholder="About"
          name="about"
          rows={3}
          required
          multiline
        />
      </Grid>

      <Grid item xs={6}>
        <Label title={"Monthly Active Users"} />

        <TextField
          disabled={!editState}
          formikProps={formikProps}
          name="monthlyActiveUsers"
          placeholder="Monthly Active Users"
          inputProps={{ type: "number" }}
        />
      </Grid>
    </React.Fragment>
  );

  function handleFileChange(event, name) {
    setLoading(true);
    let data = new FormData();

    data.append("binaryFile", event.target.files[0]);
    data.append("bucket_name", "bkt-dx-alpha-dev");
    data.append("upload_type", "image");
    data.append("foldername", "aionos");

    axios({
      url: "/binary/uploadToPlatform",
      method: "POST",
      data: data,
    }).then(function (response) {
      if (response.status) {
        formikProps.setFieldValue([name], response.data);
      }
      setLoading(false);
    });
  }
}
